import gql from "graphql-tag";
import { invoiceDetailsFields } from "../queries/getInvoice";

export const UPDATE_INVOICE = gql`mutation updateInvoice($id: ID!, $updateInvoiceInput: UpdateInvoiceInput!) {
    updateInvoice(id: $id, updateInvoiceInput: $updateInvoiceInput) {
        ${invoiceDetailsFields}
    }
}`;
